import React from 'react';
import PropTypes from 'prop-types';
import { PageSection } from 'reaxl';
import SeoDeepLinks from '@/component/SeoDeepLinks';
import { seoLinksAnalytics } from '@/analytics';

const SeoDeepLinksContainer = React.memo(({
    deepLinks,
}) => {

    const onClickHandler = (event, data) => {
        seoLinksAnalytics.fireReaxlSeoLinkClick(event, data);
    };

    return Array.isArray(deepLinks) && deepLinks.length > 0 && (
        <PageSection
            uiContext="section-2"
            headingComponentClass="h2"
            sectionContainerClassNames="row padding-top-5 padding-bottom-7 padding-left-0 padding-right-0"
            alignment="left"
            offset={1}
        >
            <SeoDeepLinks
                seoLinks={deepLinks}
                onClick={onClickHandler}
            />
        </PageSection>
    );
});

SeoDeepLinksContainer.propTypes = {
    deepLinks: PropTypes.array,
};

export default SeoDeepLinksContainer;
